export default __webpack_public_path__ + "media/images/logo-c56f2323756557709e5b1ae392ee483a.svg";